import indoorSpace, {
  ReactComponent as IndoorSpace,
} from '@assets/icons/features-and-amenities/indoor.svg'
import mixedSpace, {
  ReactComponent as MixedSpace,
} from '@assets/icons/features-and-amenities/mixed-space.svg'
import outdoorSpace, {
  ReactComponent as OutdoorSpace,
} from '@assets/icons/features-and-amenities/outdoor.svg'
import { FullCourt, fullCourt } from '@assets/icons/full-court'
import { HalfCourt, halfCourt } from '@assets/icons/half-court'
import adaIcon, {
  ReactComponent as AdaIcon,
} from '@page/listing/assets/ada-icon.svg'
import area, { ReactComponent as Area } from '@page/listing/assets/area.svg'
import asphaltCourt, {
  ReactComponent as AsphaltCourt,
} from '@page/listing/assets/asphalt-court.svg'
import basement, {
  ReactComponent as Basement,
} from '@page/listing/assets/basement.svg'
import blueCheck, {
  ReactComponent as BlueCheck,
} from '@page/listing/assets/blue-check.svg'
import cancellationPolicyIcon, {
  ReactComponent as CancellationPolicyIcon,
} from '@page/listing/assets/cancellation-policy-icon.svg'
import cementCourt, {
  ReactComponent as CementCourt,
} from '@page/listing/assets/cement-court.svg'
import chlorineIcon, {
  ReactComponent as ChlorineIcon,
} from '@page/listing/assets/chlorine-icon.svg'
import clayCourt, {
  ReactComponent as ClayCourt,
} from '@page/listing/assets/clay-court.svg'
import favoriteIconOff, {
  ReactComponent as FavoriteIconOff,
} from '@page/listing/assets/favorite-icon-off.svg'
import favoriteIconOn, {
  ReactComponent as FavoriteIconOn,
} from '@page/listing/assets/favorite-icon-on.svg'
import fiveSpace, {
  ReactComponent as FiveSpace,
} from '@page/listing/assets/five-space.svg'
import fixedNet, {
  ReactComponent as FixedNet,
} from '@page/listing/assets/fixed-net.svg'
import fourSpace, {
  ReactComponent as FourSpace,
} from '@page/listing/assets/four-space.svg'
import garage, {
  ReactComponent as Garage,
} from '@page/listing/assets/garage.svg'
import generalIcon, {
  ReactComponent as GeneralIcon,
} from '@page/listing/assets/general-icon.svg'
import grassCourt, {
  ReactComponent as GrassCourt,
} from '@page/listing/assets/grass-court.svg'
import guestsAllowedIcon, {
  ReactComponent as GuestsAllowedIcon,
} from '@page/listing/assets/guests-allowed-icon.svg'
import hardCourt, {
  ReactComponent as HardCourt,
} from '@page/listing/assets/hard-court.svg'
import hardwoodCourt, {
  ReactComponent as HardwoodCourt,
} from '@page/listing/assets/hardwood-court.svg'
import hostInteractionIcon, {
  ReactComponent as HostInteractionIcon,
} from '@page/listing/assets/host-interaction-icon.svg'
import kidsAllowed, {
  ReactComponent as KidsAllowed,
} from '@page/listing/assets/kids-allowed.svg'
import kidsNotAllowed, {
  ReactComponent as KidsNotAllowed,
} from '@page/listing/assets/kids-not-allowed.svg'
import livingRoom, {
  ReactComponent as LivingRoom,
} from '@page/listing/assets/living-room.svg'
import nonRegulationCourt, {
  ReactComponent as NonRegulationCourt,
} from '@page/listing/assets/non-regulation-court.svg'
import oneSpace, {
  ReactComponent as OneSpace,
} from '@page/listing/assets/one-space.svg'
import parkingIcon, {
  ReactComponent as ParkingIcon,
} from '@page/listing/assets/parking-icon.svg'
import petsAllowed, {
  ReactComponent as PetsAllowed,
} from '@page/listing/assets/pets-allowed.svg'
import petsNotAllowed, {
  ReactComponent as PetsNotAllowed,
} from '@page/listing/assets/pets-not-allowed.svg'
import poolDepthIcon, {
  ReactComponent as PoolDepthIcon,
} from '@page/listing/assets/pool-depth-icon.svg'
import poolSizeIcon, {
  ReactComponent as PoolSizeIcon,
} from '@page/listing/assets/pool-size-icon.svg'
import proHostIcon, {
  ReactComponent as ProHostIcon,
} from '@page/listing/assets/pro-host.svg'
import regulationCourt, {
  ReactComponent as RegulationCourt,
} from '@page/listing/assets/regulation-court.svg'
import restroomAvailable, {
  ReactComponent as RestroomAvailable,
} from '@page/listing/assets/restroom-available.svg'
import restroomIcon, {
  ReactComponent as RestroomIcon,
} from '@page/listing/assets/restroom-icon.svg'
import restroomNotAvailable, {
  ReactComponent as RestroomNotAvailable,
} from '@page/listing/assets/restroom-not-available.svg'
import ruleAllowed, {
  ReactComponent as RuleAllowed,
} from '@page/listing/assets/rule-allowed-check.svg'
import ruleNotAllowed, {
  ReactComponent as RuleNotAllowed,
} from '@page/listing/assets/rule-not-allowed-x.svg'
import saltwaterIcon, {
  ReactComponent as SaltwaterIcon,
} from '@page/listing/assets/saltwater-icon.svg'
import shareIcon, {
  ReactComponent as ShareIcon,
} from '@page/listing/assets/share-icon.svg'
import sittingArea, {
  ReactComponent as SittingArea,
} from '@page/listing/assets/sitting-area.svg'
import tempNet, {
  ReactComponent as TempNet,
} from '@page/listing/assets/temp-net.svg'
import threeSpace, {
  ReactComponent as ThreeSpace,
} from '@page/listing/assets/three-space.svg'
import twoSpace, {
  ReactComponent as TwoSpace,
} from '@page/listing/assets/two-space.svg'
import verifiedBadge, {
  ReactComponent as VerifiedBadge,
} from '@page/listing/assets/verified-badge.svg'

export const listingAssets = {
  area,
  Area,
  adaIcon,
  AdaIcon,
  asphaltCourt,
  AsphaltCourt,
  basement,
  Basement,
  blueCheck,
  BlueCheck,
  cancellationPolicyIcon,
  CancellationPolicyIcon,
  cementCourt,
  CementCourt,
  chlorineIcon,
  ChlorineIcon,
  clayCourt,
  ClayCourt,
  favoriteIconOff,
  FavoriteIconOff,
  favoriteIconOn,
  FavoriteIconOn,
  fiveSpace,
  FiveSpace,
  fixedNet,
  FixedNet,
  fourSpace,
  FourSpace,
  fullCourt,
  FullCourt,
  garage,
  Garage,
  generalIcon,
  GeneralIcon,
  guestsAllowedIcon,
  GuestsAllowedIcon,
  grassCourt,
  GrassCourt,
  hostInteractionIcon,
  HostInteractionIcon,
  halfCourt,
  HalfCourt,
  hardCourt,
  HardCourt,
  hardwoodCourt,
  HardwoodCourt,
  kidsAllowed,
  KidsAllowed,
  kidsNotAllowed,
  KidsNotAllowed,
  indoorSpace,
  IndoorSpace,
  livingRoom,
  LivingRoom,
  mixedSpace,
  MixedSpace,
  nonRegulationCourt,
  NonRegulationCourt,
  oneSpace,
  OneSpace,
  outdoorSpace,
  OutdoorSpace,
  petsAllowed,
  PetsAllowed,
  petsNotAllowed,
  PetsNotAllowed,
  regulationCourt,
  RegulationCourt,
  threeSpace,
  ThreeSpace,
  twoSpace,
  TwoSpace,
  tempNet,
  TempNet,
  parkingIcon,
  ParkingIcon,
  poolDepthIcon,
  PoolDepthIcon,
  poolSizeIcon,
  PoolSizeIcon,
  proHostIcon,
  ProHostIcon,
  restroomIcon,
  RestroomIcon,
  restroomAvailable,
  RestroomAvailable,
  restroomNotAvailable,
  RestroomNotAvailable,
  ruleAllowed,
  RuleAllowed,
  ruleNotAllowed,
  RuleNotAllowed,
  saltwaterIcon,
  SaltwaterIcon,
  shareIcon,
  ShareIcon,
  sittingArea,
  SittingArea,
  verifiedBadge,
  VerifiedBadge,
}
